import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomer,
  BackendQueryCustomerArgs,
  BackendVisualLanguage,
} from 'src/types/backend';

import { FRAGMENT_VISUAL_LANGUAGE } from './schema';

const QUERY = gql`
  query CustomerVisualLanguages($id: ID!) {
    customer(id: $id) {
      id
      visualLanguages {
        ...VisualLanguage
      }
    }
  }
  ${FRAGMENT_VISUAL_LANGUAGE}
`;

type Variables = BackendQueryCustomerArgs;
type Result = BackendVisualLanguage[];

export const queryCustomerVisualLanguages = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  const customer = getSingleProp<Pick<BackendCustomer, 'visualLanguages'>>(result.data);
  return (customer?.visualLanguages ?? []) as Result;
};
